<template lang="pug">
  .b-form-block(:class="{ mobile }")
    ._header(v-if="$slots.header")
      slot(name="header")
    slot
</template>

<script>
export default {
  name: 'FormBlock',
  props: {
    mobile: Boolean,
  },
};
</script>

<style scoped lang="scss">
.form-block {
  padding: 32px;
  background: var(--color-white);
  box-shadow: 0 6px 12px rgba(0, 0, 0, 0.08);
  border-radius: 8px;
  box-sizing: border-box;

  &__header {
    border-bottom: 1px solid #D1D9F0;
    padding-bottom: 20px;
    margin-bottom: 20px;
  }

  @media (max-width: 576px) {
    padding: 22px;

    &.mobile {
      margin-left: -15px;
      margin-right: -15px;
      border-radius: 0;
    }
  }
}
</style>
